<template>
  <div class="loading_container full-screen global-center">
    <el-icon class="iconfont icon-loading loading_button"><Loading /></el-icon>
  </div>
</template>
<script>
import { Loading } from "@element-plus/icons";
import "@/assets/icon/iconfont.css";
export default {
  components: {
    Loading,
  },
  name: "loading",
};
</script>
<style scoped>
.loading_container {
  margin-top: -2.25rem;
}
.loading_button {
  font-size: 2rem;
  color: #126de3;
  animation: round 1s infinite;
}

@keyframes round {
  0% {
    -webkit-transform: rotate(0deg);
  }
  25% {
    -webkit-transform: rotate(90deg);
  }
  50% {
    -webkit-transform: rotate(180deg);
  }
  75% {
    -webkit-transform: rotate(270deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
</style>
